import { Divider, Stack } from '@mui/material';
import { ClickableMobileDetailCard as MobileDetailCard } from 'components/MobileDetailCard';
import TableCells from 'components/TableCells';
import MobileDetailCardContents from 'pages/headliner/MobileDetailCardContents';
import { useGetPodcastSocialShareStatsDetails } from 'pages/headliner/state';
import React from 'react';
import { SocialSharePodcastEpisode } from './types';

interface PodcastsMobileListProps {
  onClick?: (val: SocialSharePodcastEpisode) => void;
  podcastId: string;
}

const PodcastsMobileList: React.FC<PodcastsMobileListProps> = ({
  onClick,
  podcastId,
}) => {
  const { data: details } = useGetPodcastSocialShareStatsDetails(podcastId);
  return (
    <Stack divider={<Divider orientation="horizontal" variant="fullWidth" />}>
      {details?.map((video) => {
        const { episodeTitle, thumbnailUrl, statistics } = video;

        const { likeCount, commentCount, viewCount, isViewCountStale } =
          statistics;

        const contents = (
          <TableCells.PodcastEpisodeCell
            episodeTitle={episodeTitle}
            thumbnailUrl={thumbnailUrl}
          />
        );

        return (
          <MobileDetailCard
            onClick={() => {
              onClick?.(video);
            }}
          >
            <MobileDetailCardContents
              details={contents}
              likeCount={likeCount}
              viewCount={viewCount}
              commentCount={commentCount}
              key={video.episodeId}
              isViewCountStale={isViewCountStale}
            />
          </MobileDetailCard>
        );
      })}
    </Stack>
  );
};

export default PodcastsMobileList;
